
(function () {
var C = window.HHCrew; if (!C) return;
var STATE = C.STATE;
var BASE = '/apps/subscriptions/cp/api/';
var MAXAGE = 1000 * 60 * 60 * 24 * 180; 
function cid() { var f = STATE && STATE.f; return f && f.focus && f.focus.idNum; }
function key() { return 'hhSkip_' + cid(); }
function get() { try { return JSON.parse(localStorage.getItem(key()) || '[]'); } catch (e) { return []; } }
function set(a) { try { localStorage.setItem(key(), JSON.stringify(a)); } catch (e) {} }
function add(id) { var a = get(); if (!a.some(function (x) { return String(x.id) === String(id); })) { a.push({ id: String(id), ts: Date.now() }); set(a); } }
function del(id) { set(get().filter(function (x) { return String(x.id) !== String(id); })); }
if (!window.__hhFetchWrapped) {
window.__hhFetchWrapped = 1;
var of = window.fetch;
window.fetch = function (u) {
var p = of.apply(this, arguments);
try {
var s = String(u);
var mu = s.match(/\/unskip-order\/(\d+)/);
var ms = s.match(/\/skip-order\/(\d+)/);
if (mu) { p.then(function (r) { try { if (r && r.ok) del(mu[1]); } catch (e) {} }); }
else if (ms) { p.then(function (r) { try { if (r && r.ok) add(ms[1]); } catch (e) {} }); }
} catch (e) {}
return p;
};
}
function topOrders() {
var id = cid(); if (!id) return Promise.resolve([]);
return fetch(BASE + 'subscription-billing-attempts/top-orders?contractId=' + id, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); }).catch(function () { return []; });
}
function unskip(id) {
C.openSheet({
title: 'Unskip this box?',
body: '<p class="hhx-sheet-p">We’ll put your skipped box back on the schedule at your normal price.</p>',
confirmLabel: 'Unskip box',
run: function () {
return fetch(BASE + 'subscription-billing-attempts/unskip-order/' + id + '?subscriptionContractId=' + cid(), { method: 'PUT', credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { if (!r.ok) throw { status: r.status }; return r.text(); });
},
success: 'Box back on the schedule.'
});
}
function inject() {
var list = get();
if (list.length) { 
var fresh = list.filter(function (x) { return (Date.now() - (x.ts || 0)) < MAXAGE; });
if (fresh.length !== list.length) { set(fresh); list = fresh; }
}
if (!list.length) return;
topOrders().then(function (orders) {
var present = {};
(Array.isArray(orders) ? orders : []).forEach(function (o) { present[String(o.id)] = 1; });
var stillSkipped = list.filter(function (x) { return !present[String(x.id)]; });
if (stillSkipped.length !== list.length) set(stillSkipped); 
if (!stillSkipped.length) return;
var wrap = document.querySelector('.hhx-actions');
if (!wrap || wrap.querySelector('[data-act="unskip-fix"]')) return;
var b = document.createElement('button');
b.type = 'button'; b.className = 'hhx-act hhx-act--on'; b.setAttribute('data-act', 'unskip-fix');
b.textContent = 'Unskip your box';
b.addEventListener('click', function () { unskip(stillSkipped[0].id); });
wrap.insertBefore(b, wrap.firstChild);
});
}
window.addEventListener('hh-crew:rendered', inject);
inject();
})();
